import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, Input, Select } from "antd";
import { createSuperAdminClinic } from "../../apis/superadmin";

const CreateClinic = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (values: any) => {
    setSubmitting(true);
    createSuperAdminClinic(values)
      .then((res: any) => {
        navigate(`/superadmin/clinics/${res.data.clinic.id}`);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="max-w-2xl">
      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={() => navigate("/superadmin")}
          className="text-sm text-gray-500 hover:text-gray-800"
        >
          ← Clinics
        </button>
        <span className="text-gray-300">/</span>
        <h1 className="text-xl font-bold text-gray-900">New Clinic</h1>
      </div>

      <div className="bg-white rounded-lg shadow-sm p-6">
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <h2 className="text-sm font-semibold text-gray-600 uppercase tracking-wide mb-4">
            Clinic Details
          </h2>
          <Form.Item name="name" label="Clinic Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <div className="grid grid-cols-2 gap-x-4">
            <Form.Item name="phone" label="Phone" rules={[{ required: true, len: 10, message: "Must be 10 digits" }]}>
              <Input maxLength={10} />
            </Form.Item>
            <Form.Item name="email" label="Email (used for admin login)" rules={[{ required: true, type: "email" }]}>
              <Input />
            </Form.Item>
          </div>
          <Form.Item name="address" label="Address" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <div className="grid grid-cols-2 gap-x-4">
            <Form.Item name="zip" label="ZIP Code" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item name="country" label="Country" rules={[{ required: true }]} initialValue="India">
              <Input />
            </Form.Item>
          </div>
          <div className="grid grid-cols-2 gap-x-4">
            <Form.Item name="plan" label="Plan" rules={[{ required: true }]} initialValue="free">
              <Select>
                <Select.Option value="free">Free</Select.Option>
                <Select.Option value="essential">Essential</Select.Option>
                <Select.Option value="flexivisit">FlexiVisit</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name="numberOfUsers" label="Number of Doctors" rules={[{ required: true }]} initialValue={1}>
              <Input type="number" min={1} />
            </Form.Item>
          </div>

          <h2 className="text-sm font-semibold text-gray-600 uppercase tracking-wide mb-4 mt-2">
            Admin Contact
          </h2>
          <div className="grid grid-cols-2 gap-x-4">
            <Form.Item name="firstName" label="First Name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item name="lastName" label="Last Name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </div>

          <p className="text-xs text-gray-500 mb-4">
            A password setup email will be sent to the admin at the email above.
          </p>

          <div className="flex justify-end gap-3">
            <Button onClick={() => navigate("/superadmin")}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={submitting}>
              Create Clinic
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default CreateClinic;
